<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      Quel établissement effectuant la demande ?
    </BasicText>
    <WrapperAutocomplete
      v-model="data"
      :search
      key-id="siret.valeur"
      key-label="denomination"
      placeholder="Siren, siret ou dénomination..."
      :search-min-length="1"
      label="Etablissement effectuant demande"
      strict
      :search-formater="sirenSiretSearchFormater"
    >
      <template v-slot="item">
        <div class="item">
          <BasicText
            weight="bold"
            size="body-m"
          >
            {{ item.denomination }}
            <BasicText
              v-if="item.estEtablissementSiege === true"
              color="primary-600"
              weight="bold"
            >
              - SIEGE
            </BasicText>
            <BasicText
              v-if="item.etatAdministratif === 'F'"
              color="red"
            >
              (Inactif)
            </BasicText>
          </BasicText>

          <BasicText size="body-s">
            {{ item.siret.siren }} {{ item.siret.nic }} - {{ item.adresse?.codePostal }} {{ item.adresse?.commune }}
          </BasicText>
        </div>
      </template>
    </WrapperAutocomplete>
  </div>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount, ref } from 'vue'
  import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
  import type { EtablissementAdherentDTO } from '@/features/api/extranet/dto/shared'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'
  import services from '@/features/services/demande/DemandeAllService'
  import { isNullUndefinedOrEmptyString } from '@/features/shared/tools'

  const props = defineProps<CarteProps<RattachementDTO, EtablissementAdherentDTO>>()
  const emits = defineEmits<CarteEvents<EtablissementAdherentDTO>>()

  const data = computed<EtablissementAdherentDTO | undefined>({
    get: () => props.out,
    set: (value) => {
      const outReady = !!value?.siret?.valeur
      emits('outChanged', outReady, value)
    },
  })

  const arrayEtablissements = ref<EtablissementAdherentDTO[]>(props.transitionState)

  onBeforeMount(async () => {
    // Ne recharge pas le tableau en cas de GoBack du process
    if (arrayEtablissements.value) return

    try {
      arrayEtablissements.value = await services.searchEtablissementAdherent(
        props.in.identifiantEntiteJuridique,
        { dialogMode: 'silent' },
      )
    } catch (err) {
      console.log(err)
    }
  })

  const search = (query: string) => {
    query = query.trim().toLowerCase()
    if (isNullUndefinedOrEmptyString(query)) return arrayEtablissements.value!

    return arrayEtablissements.value!.filter(
      (etab) =>
        etab.denomination?.toLocaleLowerCase()?.includes(query) ||
        etab.siret.valeur?.includes(query) ||
        etab.adresse?.commune?.toLocaleLowerCase().includes(query),
    )
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
